import React, { useContext, useEffect, useState } from 'react';
import { Col, Card, Navbar, Nav } from "react-bootstrap";
import { FaArrowLeft } from "react-icons/fa";
import axios from 'axios';
import { site_url } from "../config.js";
import "bootstrap/dist/css/bootstrap.min.css";
import "./styles.css";
import { useLocation, useSearchParams } from 'react-router-dom';
import { AuthContext } from '../AuthContext';
import { parseStoredAccessToken } from '../parseStoredAccessToken.js';
import { parseWalletAmount } from '../parseWalletAmount.js';
import { FormatDate } from '../Function';

function Index() {
  const { user } = useContext(AuthContext);
  const [data, setData] = useState([]);
  const [totalExpired, setTotalExpired] = useState(0);
  const [loading, setLoading] = useState(true);
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const scope = searchParams.get('scope') === 'this_month' ? 'this_month' : 'expired';
  const isThisMonth = scope === 'this_month';

  useEffect(() => {
    const backdrops = document.querySelectorAll(".modal-backdrop");
    backdrops.forEach((el) => el.remove());
    document.body.classList.remove("modal-open");
    document.body.style.overflow = "";
    document.body.style.paddingRight = "";
  }, [location]);

  const goBack = () => {
    window.history.back();
  };

  useEffect(() => {
    getExpiredTransactions();
  }, [user, scope]);

  const getExpiredTransactions = async () => {
    const token = parseStoredAccessToken(user);
    if (!token) {
      setLoading(false);
      return;
    }

    setLoading(true);
    try {
      const res = await axios.get(site_url + "/customer/expired-transactions", {
        params: { scope },
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: 'application/json',
        },
      });

      if (res.data.status === 'success') {
        setData(res.data.data || []);
        setTotalExpired(parseWalletAmount(
          isThisMonth
            ? (res.data.total_original ?? res.data.total_expired)
            : res.data.total_expired
        ));
      }
    } catch (err) {
      console.error("API Error:", err?.response?.data || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-vh-100">
      <Navbar expand="lg" className="navbar px-3">
        <Navbar.Brand className="fw-bold text-white">
          <center>
            <FaArrowLeft onClick={goBack} className="fs-5 text-white notificaton-icon" /> {isThisMonth ? 'Expiring This Month' : 'Expired Points'}
          </center>
        </Navbar.Brand>
        <Nav className="ms-auto d-flex align-items-center" />
      </Navbar>

      <div className="p-3">
        <Card className="mb-3 expired-summary-card">
          <Card.Body className="text-center text-white">
            <div style={{ fontSize: '13px', opacity: 0.9 }}>
              {isThisMonth ? 'Coins expiring this month' : 'Total expired coins'}
            </div>
            <div style={{ fontSize: '28px', fontWeight: 'bold', marginTop: '6px' }}>
              🪙 {totalExpired.toFixed(2)}
            </div>
          </Card.Body>
        </Card>

        {loading && (
          <div className="text-center py-4 text-muted">Loading...</div>
        )}

        {!loading && data.length === 0 && (
          <div className="text-center py-4 text-muted">
            {isThisMonth ? 'No coins expiring this month.' : 'No expired transactions found.'}
          </div>
        )}

        {!loading && data.map((item) => (
          <div className="col-12 p-1" key={item.id}>
            <Col xs={12}>
              <Card>
                <Card.Body>
                  <div className="row">
                    <div className="col-4">
                      <center><img src={'./wallet.png'} className="shoplist_img" alt="" /></center>
                    </div>
                    <div className="col-8">
                      <p className="shoplist_dcr" style={{ marginBottom: '2px' }}>Original Reward Coins</p>
                      <h3><span className="shoplist_text">🪙 {parseWalletAmount(item.original_amount ?? item.amount).toFixed(2)}</span></h3>
                      <p className="shoplist_dcr">Type: {item.bonus_type}</p>
                      <p className="shoplist_dcr">{item.status === 'expiring' ? 'Expires on' : 'Expired on'}: {FormatDate(item.expired_at || item.expires_at)}</p>
                      {item.expired_amount != null && item.status === 'expired' && parseWalletAmount(item.expired_amount) !== parseWalletAmount(item.original_amount ?? item.amount) && (
                        <p className="shoplist_dcr">Leftover expired: 🪙 {parseWalletAmount(item.expired_amount).toFixed(2)}</p>
                      )}
                      {item.available_amount != null && item.status === 'expiring' && (
                        <p className="shoplist_dcr">Still available: 🪙 {parseWalletAmount(item.available_amount).toFixed(2)}</p>
                      )}
                      <p className="shoplist_dcr">Recorded: {FormatDate(item.created_at)}</p>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Index;
